export interface PerformanceRun {
  savedPerformanceRunId: string;
  visibleSixRowLayoutValues: RowLayout[] | undefined;
  visibleTenRowLayoutValues: RowLayout[] | undefined;
  visibleSixRowLayoutValues_high: any[] | undefined;
  visibleTenRowLayoutValues_high: any[] | undefined;
  speedMaxVal: number;
  speedMinVal: number;
  speedMaxVal_std: number;
  speedMaxVal_high: number;
  speedMinVal_std: number;
  speedMinVal_high: number;
  inclineMinVal: number;
  inclineMaxVal: number;
  inclineMinVal_std: number;
  inclineMaxVal_std: number;
  inclineMinVal_high: number;
  inclineMaxVal_high: number;
  preferredUnit: string;
  layoutType: string | undefined;
  showSixRowLayout: boolean | undefined;
  showTenRowLayout: boolean | undefined;
}

export interface RowLayout {
  incline: string;
  orderId: string;
  speedEn: string;
  speedMt: string;
}

export enum VisibleRowLayout {
  visibleSixRowLayoutValuesIncludeKeys = 'visibleSixRowLayoutValuesIncludeKeys',
  visibleSixRowLayoutValuesSpeedKeys = 'visibleSixRowLayoutValuesSpeedKeys',
  visibleTenRowLayoutValuesIncludeKeys = 'visibleTenRowLayoutValuesIncludeKeys',
  visibleTenRowLayoutValuesSpeedKeys = 'visibleTenRowLayoutValuesSpeedKeys',
  visibleSixRowLayoutValues_highIncludeKeys = 'visibleSixRowLayoutValues_highIncludeKeys',
  visibleSixRowLayoutValues_highSpeedKeys = 'visibleSixRowLayoutValues_highSpeedKeys',
  visibleTenRowLayoutValues_highIncludeKeys = 'visibleTenRowLayoutValues_highIncludeKeys',
  visibleTenRowLayoutValues_highSpeedKeys = 'visibleTenRowLayoutValues_highSpeedKeys',
}

export enum PerformanceRunKeysType {
  includeKey = 'includeKey',
  speedKeys = 'speedKeys'
}

export interface PerformanceRunPayload {
  facilityId: string;
  consoleType: string;
  activityId: string | null;
}

export interface PerformanceRunEquipList {
  connectedCount: string;
  notConnectedCount: string;
  performanceRunAssetsList: PerformanceRunAssets[];
}

export interface  PerformanceRunAssets {
  activityId: string;
  assetId: string;
  bodySerial: string;
  confirmation: string;
  isConnected: string;
  modelId: string;
  published: string;
  isClickedOnPublish?: boolean;
}
